import { SET_STOCK_INGREDIENT, SET_OUTFLOW, SET_INFLOW } from '../types';

const initialState = {
  data: [],
  singleIngredient: {
    id: '',
    ing_id: '',
    date: new Date(),
    name: '',
    reason: '',
    quantity: 0,
    unit: '',
    details: '',
    isError: '',
  },
  outflow: {
    id: '',
    ing_id: '',
    date: new Date(),
    name: '',
    reason: '',
    quantity: 0,
    unit: '',
    details: '',
    isError: '',
  },
  inflow: {
    id: '',
    ing_id: '',
    date: new Date(),
    name: '',
    reason: '',
    quantity: 0,
    unit: '',
    details: '',
    isError: '',
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_STOCK_INGREDIENT:
      return { ...state, singleIngredient: action.singleIngredient };
    case SET_INFLOW:
      return { ...state, inflow: action.inflow };
    case SET_OUTFLOW:
      return { ...state, outflow: action.outflow };
    default:
      return state;
  }
}
